<script lang="ts" setup>
/* Components */
const BasketErrorMessage = defineAsyncComponent(
  () => import('@/components/Basket/basket-utils/BasketErrorMessage.vue'),
)
const BasketWarningMessage = defineAsyncComponent(
  () => import('@/components/Basket/basket-utils/BasketWarningMessage.vue'),
)

type Props = {
  errorMessage?: string
  warningMessage?: string
  warningIcon?: string
}

defineProps<Props>()
</script>

<template>
  <basket-error-message v-if="errorMessage" :error-message="errorMessage" />

  <basket-warning-message
    v-else-if="warningMessage"
    :message="warningMessage"
    :icon="warningIcon"
    class="warning-message"
  />
</template>

<style lang="scss">
.warning-message {
  padding-bottom: 30px;
}
</style>
